import React from "react";
import { createRoot }   from 'react-dom/client';
//import ReactDOM from "react-dom";
import { BrowserRouter, Route} from "react-router-dom";
import configureStore from "./store/configureStore";
import { unregister } from "./registerServiceWorker";
import { Provider } from "react-redux";
import App from "./App";
import axios from "axios";
import { utils } from "./common/utils";

const store = configureStore();
const state = store.getState();

if (state) {
    // Init user Cart
    if (!state.cart || !state.cart.lines) {
        axios.defaults.headers.common['locale'] = state.locale
    }

    // Init user session to keep user logged in
    if (state.user && state.user.accessToken) {
        axios.defaults.headers.common['Authorization'] = state.user.accessToken;
        axios.defaults.headers.common['withCredentials'] = 'true';
        axios.defaults.headers.common['userId'] = state.user.userId;
    }
    // Init user locale
    if (state.locale) {
        axios.defaults.headers.common['locale'] = state.locale
    }

   
}

store.subscribe(() => {
    const state = store.getState();
    utils.settings = state.settings;
    // Save state to local storage
    //localStorage.setItem("shopState", JSON.stringify({ cart: state.cart, wishlist: state.wishlist, user: state.user }));
    localStorage.setItem("shopState", JSON.stringify({ cart: state.cart, wishlist: state.wishlist, user: state.user, checkoutSale: state.checkoutSale, openpayPlan: state.openpayPlan }));
    localStorage.setItem("locale", state.locale);
});

const rootElem = document.getElementById("root");
if (rootElem === null) {
    throw new Error("No root element found");
} else {
    // Create a root.
    const root = createRoot(rootElem);

    // Initial render: Render an element to the root. REACT V18
    root.render(
        <Provider store={store}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Route path="/:shopName?" component={App} />

        </BrowserRouter>
    </Provider>);

    // REACT V17
    //ReactDOM.render(
    //    <Provider store={store}>
    //        <BrowserRouter basename={process.env.PUBLIC_URL}>
    //            <Route path="/:shopName?" component={App} />
             
    //        </BrowserRouter>
    //    </Provider>,
    //    rootElem
    //);
    unregister();
   // window.location.protocol === 'https:' && registerServiceWorker();
}
